<template>
    <PortalAuth>
        <div class="d-flex align-items-center min-vh-100">
            <CContainer fluid>
                <CRow class="justify-content-center">
                    <CCol lg="7" md="9" sm="10" style="max-width: 500px">
                        <CCard class="mx-sm-2 mx-md-4 mb-0">
                            <CCardBody class="p-4">
                                <CForm @submit.prevent="onSubmit">
                                    <h2 style="text-align:center">Request access</h2>
                                    <CInput
                                        v-model="form.email"
                                        placeholder="Email"
                                        autocomplete="email"
                                        name="email"
                                        type="email"
                                        class="mt-4"
                                        :readonly="requestWasSent"
                                        required
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilEnvelopeOpen"/>
                                        </template>
                                    </CInput>
                                    <CRow>
                                        <CCol class="d-flex justify-content-center">
                                            <CInputCheckbox
                                                label="Coach"
                                                custom
                                                :readonly="requestWasSent"
                                                :checked.sync="form.coachFlag"

                                            />
                                        </CCol>
                                        <CCol class="d-flex justify-content-center">
                                            <CInputCheckbox
                                                label="Athlete"
                                                custom
                                                :readonly="requestWasSent"
                                                :checked.sync="form.athleteFlag"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CInput
                                        v-model="form.name"
                                        placeholder="Name"
                                        class="mt-4"
                                        :readonly="requestWasSent"
                                        required
                                    >
                                        <template #prepend-content>
                                            <CIcon/>
                                        </template>
                                    </CInput>
                                    <CInput
                                        v-model="form.organisation"
                                        placeholder="Organisation"
                                        class="mt-4"
                                        :readonly="requestWasSent"
                                    >
                                        <template #prepend-content>
                                            <CIcon/>
                                        </template>
                                    </CInput>

                                    <CInput
                                        v-model="form.howFoundUs"
                                        placeholder="How did you find us?"
                                        class="mt-4"
                                        :readonly="requestWasSent"
                                        required
                                    >
                                        <template #prepend-content>
                                            <CIcon/>
                                        </template>
                                    </CInput>

                                    <FormErrors :errors="errors"/>
                                    <div v-if="!requestWasSent" class="mt-4" style="text-align:center">
                                        <CButton class="w-100" type="submit" color="info"  :disabled="this.graphqlLoadingFlag">Submit</CButton>
                                    </div>
                                    <p class="mt-3" v-if="requestWasSent">Thank you! We will notify you.
                                        <CLink :to="{name: 'main'}">Go to main</CLink>
                                    </p>
                                </CForm>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    </PortalAuth>
</template>

<script>
    import {
        getProcessedAuthResponseErrorsFlat
    } from '@/scripts/auth-utils'
    import {onSubmitHandler} from '@/scripts/forms-utils'

    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'
    import gql from "graphql-tag"

    export default {
        components: {PortalAuth, FormErrors},
        data() {
            return {
                errors: [],
                graphqlLoadingFlag: false,
                requestWasSent: false,
                form: {
                    email: '',
                    name: '',
                    coachFlag: false,
                    athleteFlag: false,
                    howFoundUs: '',
                    organisation: ''
                }
            }
        },
        methods: {
            async onSubmit() {
                let mutation = gql`
                        mutation preRegistrationRequest ($email: String!, $name: String!, $coachFlag: Boolean!, $athleteFlag: Boolean!, $organisation: String, $howFoundUs: String!) {
                            preRegistrationRequest(email: $email, name: $name, coachFlag: $coachFlag, athleteFlag: $athleteFlag, organisation: $organisation, howFoundUs: $howFoundUs) {
                                success,
                                errors
                            }
                        }
                `

                this.requestWasSent = false
                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.requestWasSent = true,
                        mutationVariables: this.form
                    })
            }
        }
    }
</script>
